import {Injectable} from '@angular/core';
import {CCRolesType} from "../../model/security/cc-roles-type";
import {SessionNames} from "../../shared/session/session-names";

@Injectable({
  providedIn: 'root'
})
export class RolesService {

  get userRoles(): CCRolesType.Roles[] {
    return JSON.parse(sessionStorage.getItem(SessionNames.USER_ROLES) || 'null') || [];
  }

  constructor() {
  }

  isAdmin(): boolean {
    return this.hasRoles([CCRolesType.Roles.ROLE_SYSTEM]);
  }

  hasRoles(rolesFilter: CCRolesType.Roles[]): boolean {
    let hasRoles: boolean = false;
    const userRoles = this.userRoles;
    if (userRoles) {
      userRoles.forEach(value => {
        if (rolesFilter.some(r => r == value)) {
          hasRoles = true;
        }
      });
    }
    return hasRoles;
  }

}
